import { SubscriptionEvent } from '@fiverr-private/bianka_js/protobuf/bianka/event/activity/v2/extension/subscription/subscription';
import { PackageType as BIPackageType } from '@fiverr-private/bianka_js/protobuf/bianka/event/activity/v2/extension/subscription/common/package_type';
import { ElementType } from '@fiverr-private/bianka_js';
import { PackageType, PackageTypeWithFiverr } from '../types/plan';
import { biEvent } from '.';

const PACKAGE_TYPE_TO_BI: Record<PackageTypeWithFiverr, BIPackageType> = {
    pro_advanced: BIPackageType.PRO_ADVANCED,
    pro_essential: BIPackageType.PRO_ESSENTIAL,
    fiverr: BIPackageType.FIVERR,
};

interface SubscriptionEventParams {
    pageName: string;
    currentPlan: PackageType;
    eventType: string;
    componentName: string;
    componentType: keyof typeof ElementType;
    targetPlan?: PackageTypeWithFiverr;
    sellerId?: number;
    upgradeSource?: string;
}

export const clickSubscriptionEvent = ({
    currentPlan,
    pageName,
    componentName,
    componentType,
    eventType,
    targetPlan,
    sellerId,
    upgradeSource,
}: SubscriptionEventParams) => {
    biEvent.click<SubscriptionEvent>(pageName, {
        event: {
            type: eventType,
            element: {
                name: componentName,
                type: ElementType[componentType],
                text: { value: upgradeSource || '' },
            },
            ...(sellerId ? { seller: { id: sellerId } } : {}),
        },
        additionalData: {
            type: SubscriptionEvent,
            message: {
                currentPlan: PACKAGE_TYPE_TO_BI[currentPlan],
                targetPlan: targetPlan ? PACKAGE_TYPE_TO_BI[targetPlan] : BIPackageType.UNSPECIFIED,
            },
        },
    });
};

export const hoverSubscriptionEvent = ({
    currentPlan,
    pageName,
    componentName,
    componentType,
    eventType,
    targetPlan,
}: SubscriptionEventParams) => {
    biEvent.hover<SubscriptionEvent>(pageName, {
        event: {
            type: eventType,
            element: {
                name: componentName,
                type: ElementType[componentType],
            },
        },
        additionalData: {
            type: SubscriptionEvent,
            message: {
                currentPlan: PACKAGE_TYPE_TO_BI[currentPlan],
                targetPlan: targetPlan ? PACKAGE_TYPE_TO_BI[targetPlan] : BIPackageType.UNSPECIFIED,
            },
        },
    });
};
